/**
 * One on-device notice in the employee bell — today only "payslip
 * downloaded". Renders through the shared `BellRow`, so it reads as one list
 * with the leave-decision rows.
 */
import { useTranslation } from '@mukil/i18n';
import type { DeviceNotification } from '../../data/device_notifications.js';
import { format_month_year } from '../../lib/format.js';
import { BellRow, BellRowIcon } from './bell_row.js';

export function DeviceNoticeRow({
  notice,
  relative_time,
  onOpen,
}: {
  notice: DeviceNotification;
  relative_time: string;
  onOpen: () => void;
}): React.JSX.Element {
  const { t, locale } = useTranslation('wp');
  return (
    <BellRow
      icon={
        <BellRowIcon className="bg-[color:var(--accent-tint)] text-[color:var(--accent)]">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </BellRowIcon>
      }
      title={t('my_pay.downloaded_notification_title')}
      time={relative_time}
      onOpen={onOpen}
      testId="employee-device-notification-item"
    >
      {/* Just the period: inside the app the row itself is the thing you
          tap, so the lock-screen "Tap to open" wording would be redundant. */}
      <span className="block text-[12.5px] text-[color:var(--ink-muted)] mt-0.5">
        {t('my_pay.payslip_for', {
          period: format_month_year(notice.period, locale),
        })}
      </span>
    </BellRow>
  );
}
